import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Theme {
    mediaQueries: {
      landscapeMobile: string;
    };
  }
  interface ThemeOptions {
    mediaQueries?: {
      landscapeMobile?: string;
    };
  }
}

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: false;
    sm: false;
    md: false;
    lg: false;
    xl: false;
    mobile: true;
    iphone5: true;
    tablet: true;
    laptop: true;
    desktop: true;
  }
}

export const theme = createTheme({
  breakpoints: {
    values: {
      mobile: 0,
      iphone5: 340,
      tablet: 640,
      laptop: 1024,
      desktop: 1200,
    },
  },
  // landscape mobile orientation
  mediaQueries: {
    landscapeMobile:
      '@media (max-width: 1024px) and (max-height: 640px) and (orientation: landscape)',
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: 0,
          backgroundColor: 'transparent',
          borderRadius: 8,
        },
      },
    },
  },
});
